import { buildCloudinaryTransforms } from '#app/utilities/cloudinaryTransforms/buildCloudinaryTransforms.js';
import { type CloudinaryTransformOptions } from '#app/utilities/cloudinaryTransforms/types.js';

export const getAssetUrl = ({
  assetType,
  transformOptions,
  uid,
}: {
  assetType: 'image' | 'video';
  transformOptions: CloudinaryTransformOptions;
  uid: string;
}): string => {
  // We intentionally fetch video and audio directly from Cloudinary because these files have issues playing when served through our CDN
  const baseUrl =
    transformOptions.format === 'mp4' || transformOptions.format === 'webm'
      ? 'https://res.cloudinary.com/contra'
      : 'https://media.contra.com';

  return [
    `${baseUrl}/${assetType}/upload`,
    buildCloudinaryTransforms(transformOptions),
    uid,
  ]
    .filter(Boolean)
    .join('/');
};
